import { GetterTree } from 'vuex';
import { IRootState } from '../../../shared/store/shared.types';
import { ISignState } from './signature.types';

const signGetters: GetterTree<ISignState, IRootState> = {
  signature(state): string {
    return state.signature;
  },
};

export default signGetters;
